export default {
  'en-SG': {
    currency: {
      style: 'currency',
      currency: 'SGD'
    }
  },
  'en-PH': {
    currency: {
      style: 'currency',
      currency: 'PHP'
    }
  },
  'ms-MY': {
    currency: {
      style: 'currency',
      currency: 'MYR'
    }
  }
};
